var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['toggle-container', { toggled: _vm.value, disabled: _vm.disabled }],on:{"click":function($event){return _vm.toggleValue()}}},[_c('div',{staticClass:"toggle"})])}
var staticRenderFns = []

export { render, staticRenderFns }